import {KTCard} from '../../../_metronic/helpers'
import {ListHeader} from './components/header/ListHeader'

import {FaqQnaTable} from './FaqQnaTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {FaqQnaEditModal} from './faq-qna-add-edit/FaqQnasEditModal'

const FaqQnaList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <FaqQnaTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <FaqQnaEditModal />}
    </>
  )
}

const FaqQnaListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <FaqQnaList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {FaqQnaListWrapper}
